import { DeepPartial, LocaleConfig } from '@empathybroker/ebx-gluon';
import * as currencies from './currency';
import * as messages from './messages';

export const MOBILE_LOCALE_CONFIG: DeepPartial<LocaleConfig> = {
  currencies,
  messages
};
